import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetAdditionalDocumentRequests,
	GetAdditionalDocumentRequestsModel,
	GetAdditionalDocumentRequestsParams,
} from 'domain/usecases';

export class RemoteGetAdditionalDocumentRequests implements GetAdditionalDocumentRequests {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAdditionalDocumentRequestsModel>,
	) {}

	async get(params: GetAdditionalDocumentRequestsParams): Promise<GetAdditionalDocumentRequestsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
